<br />
<br />
<div class="container">
    <h1 class="line-background">
        <span>{{ "processando_pagamento" | translate }}</span>
    </h1>
</div>